Ext.define('SA.model.createimport.FileTuple', {
    constructor({file, unit}) {
        this.file = file;
        this.unit = unit;
        this.columnDefinitionList = null;
    },

    getColumnCount() {
        return this.file.getColumnCount();
    },

    getColumnValues(headerName) {
        return this.getFile().getColumnValues(headerName);
    },

    getDataColumnCount() {
        return this.getDataColumnDefinitions().length;
    },

    getDataColumnDefinitions() {
        return this.columnDefinitionList.getDataColumnDefinitions();
    },

    getDataColumns() {
        return this.getDataColumnDefinitions().map(definition => {
            var headerName = definition.getHeaderName(),
                values = this.getColumnValues(headerName);

            return {headerName, values};
        });
    },

    getFile() {
        return this.file;
    },

    getFileName() {
        return this.file.getFileName();
    },

    getHeaderNames() {
        return this.file.getHeaderNames();
    },

    getLocationColumnCount() {
        return this.getLocationColumnDefinitions().length;
    },

    getLocationColumnDefinitions() {
        return this.columnDefinitionList.getLocationColumnDefinitions();
    },

    getLocationColumnHeaderName() {
        return this.getLocationColumnDefinitions()[0].getHeaderName();
    },

    getLocationColumnValues() {
        return this.getColumnValues(this.getLocationColumnHeaderName());
    },

    getUnit() {
        return this.unit;
    },

    serializeForRequest() {
        var fileName = this.getFileName(),
            geographicUnit = this.getUnit(),
            locationColumn = this.getLocationColumnHeaderName(),
            contents = this.getFile().getContents();

        return {fileName, geographicUnit, locationColumn, contents};
    },

    serializeForReview() {
        var fileName = this.getFileName(),
            unit = SA.data.GeographicUnits.get(this.getUnit()).name;

        return {fileName, unit};
    },

    setColumnDefinitions(columnDefinitions) {
        var headerNames = this.getHeaderNames(),
            fileHasColumn = definition => headerNames.includes(definition.getHeaderName()),
            filteredDefinitions = columnDefinitions.filter(fileHasColumn);

        this.columnDefinitionList = new SA.model.createimport.ColumnDefinitionList(filteredDefinitions);
    }
});